import PocketBase from 'pocketbase';

/* The same PocketBase instance the rest of CORE uses. That is the entire reason login is
   shared: Alyssa, Jason and Adorian already have active `users` records and roster rows
   there, and the Google provider is already configured. A separate PB would have meant a
   separate users table and a separate OAuth client — i.e. NOT the same login. */

const PB_URL =
  import.meta.env.VITE_PB_URL ||
  import.meta.env.VITE_POCKETBASE_URL ||
  'https://core-pb.viralitypipeline.com';

export const pb = new PocketBase(PB_URL);

export const PB_BASE_URL = PB_URL;
